module.exports = __webpack_public_path__ + "media/img/icon1-a8cf759aceecb2fdd560e1338d3d470a.svg";